import React, { useEffect, useState, useMemo, useCallback } from 'react';
import CreateTableComponent from "../share/CreateTableComponent";
import {
  Modal, ModalHeader, ModalBody, ModalFooter,
  Button, Badge, Form, FormGroup, Label, Input, Spinner, Alert, Table
} from "reactstrap";
import { FiSearch, FiEdit2, FiClock, FiPaperclip } from "react-icons/fi";
import { useFormik } from "formik";
import { NumberWithCommas } from "../share/NumberWithCommas";


/** helper: ดึงค่าจาก camelCase หรือ PascalCase ได้ */
const pick = (obj, ...keys) => {
  for (const k of keys) {
    if (obj && Object.prototype.hasOwnProperty.call(obj, k) && obj[k] !== undefined) return obj[k];
  }
  return null;
};

/** helper: แปลงค่าว่างเป็น "-" */
const show = (v) => (v === null || v === undefined || v === "" ? "-" : v);

/** helper: ดึง id/name ของ enum (รองรับหลายรูปแบบ) */
const anyId = (e) => pick(e, "debtStatusId", "DebtStatusId", "id", "Id", "value", "Value", "enumId", "EnumId");
const anyName = (e) => pick(e, "debtStatusName", "DebtStatusName", "name", "Name", "text", "Text", "label", "Label");

export const ResultBorrowingComponent = () => {
  const user = JSON.parse(localStorage.getItem("userData") || "{}");
  // console.log("user", user);
  const [dataBorrow, setDataBorrow] = useState([]);
  const [listDebtStatus, setListDebtStatus] = useState([]);
  const [detailOpen, setDetailOpen] = useState(false);
  const [selected, setSelected] = useState(null);

  // --- states สำหรับ Edit Modal ---
  const [dataEdit, setDataEdit] = useState(null);
  const [showEditForm, setShowEditForm] = useState(false);
  const [saving, setSaving] = useState(false);
  const [formError, setFormError] = useState("");
  const [formSuccess, setFormSuccess] = useState("");

  // const modalEditForm = () => setShowEditForm(!showEditForm);

  // --- states สำหรับ Log Modal ---
  const [showLogModal, setShowLogModal] = useState(false);
  const [logItems, setLogItems] = useState([]); // DebtLogBorrowViewModel[]
  const [logLoading, setLogLoading] = useState(false);
  const [logError, setLogError] = useState("");
  const [logForBorrowId, setLogForBorrowId] = useState(null);
  // โหลดรายการสถานะลูกหนี้
  useEffect(() => {
    const getListDebt = async () => {
      try {
        const res = await fetch("/api/MasterData/mdListDebt");
        const resJson = await res.json();
        const arr = (resJson?.dataenum ?? []).map(s => ({
          debtStatusId: anyId(s),
          debtStatusName: anyName(s),
        }));
        setListDebtStatus(arr);
      } catch (err) {
        // console.log("load listDebtStatus error:", err);
      }
    };
    getListDebt();
  }, []);

  // โหลดข้อมูลการกู้ยืม
  const fetchDataBorrow = useCallback(async () => {
    try {
      const res = await fetch("/api/Borrow/dataBorrowing", {
        headers: {
          "Content-type": "application/json",
          "token": user?.token || "",
        },
      });
      const resJson = await res.json();
      setDataBorrow(resJson?.dataenum ?? []);
    } catch (e) {
      // console.log("err", e);
    }
  }, [user?.token]);

  useEffect(() => { fetchDataBorrow(); }, [fetchDataBorrow]);

  // --- เปิด/ปิด modal รายละเอียด ---
  const openDetail = (rowData) => { setSelected(rowData); setDetailOpen(true); };
  const closeDetail = () => { setDetailOpen(false); setSelected(null); };

  // เมื่อกดแก้ไข: เปิด Edit Modal + setDataEdit
  const onClickEdit = (rowOriginal) => {
    setDataEdit(rowOriginal);
    setFormError("");
    setFormSuccess("");
    setShowEditForm(true);
  };


  const openLog = async (rowOriginal) => {
    const bid = Number(pick(rowOriginal, "borrowId", "BorrowId"));
    setLogForBorrowId(bid || null);
    setShowLogModal(true);
    setLogItems([]);
    setLogError("");
    setLogLoading(true);

    try {
      // สมมติ endpoint ตาม service: ListDebtLog(long borrowId)
      // สามารถปรับได้เป็น /api/Borrow/listDebtLog/{borrowId} ถ้า backend ใช้ route แบบนั้น
      const res = await fetch(`/api/Borrow/listDebtLog/${bid}`, {
        headers: {
          "Content-type": "application/json",
          "token": user?.token || "",
        },
      });
      const resJson = await res.json();

      if (!res.ok || resJson?.isSuccess === false) {
        throw new Error(resJson?.message || "ไม่สามารถโหลด Log ได้");
      }

      const items = resJson?.dataenum ?? resJson?.data ?? [];
      // เรียงใหม่ล่าสุดอยู่บน (ถ้า backend ไม่ได้เรียงมา)
      const sorted = [...items].sort((a, b) => {
        const da = new Date(pick(a, "createDate", "CreateDate") || 0).getTime();
        const db = new Date(pick(b, "createDate", "CreateDate") || 0).getTime();
        return db - da;
      });
      setLogItems(sorted);
    } catch (err) {
      setLogError(err?.message || "เกิดข้อผิดพลาดในการโหลด Log");
    } finally {
      setLogLoading(false);
    }
  };

  const closeLog = () => {
    setShowLogModal(false);
    setLogItems([]);
    setLogError("");
    setLogForBorrowId(null);
  };
  // คอลัมน์ตาราง
  const COLUMNS = useMemo(() => [
    // {
    //   Header: "เลขที่อ้างอิง",
    //   accessor: "borrowId",
    //   Cell: ({ row }) => <div className='d-flex justify-content-start'>
    //     {show(pick(row.original, "borrowId", "BorrowId"))}
    //   </div>
    // },
    {
      Header: "เลขที่คำขอ",
      accessor: "borrowNumber",
      Cell: ({ row }) => <div className='d-flex justify-content-end'>
        {show(pick(row.original, "borrowNumber", "BorrowNumber"))}
      </div>
    },
    {
      Header: "เลขที่สัญญา",
      accessor: "borrowContact",
      Cell: ({ row }) => <div className='d-flex justify-content-end'>
        {show(pick(row.original, "borrowContact", "BorrowContact"))}
      </div>
    },
    {
      Header: "ชื่อผู้ขอกู้",
      accessor: "employee",
      Cell: ({ row }) => <div className='d-flex justify-content-start'>
        {show(pick(row.original, "employee", "Employee"))}
      </div>
    },
    {
      Header: "ครั้งที่",
      accessor: "meetingNo",
      Cell: ({ row }) => <div className='d-flex justify-content-end'>
        {row.original.meetingNo}
      </div>
    },
    {
      Header: "วันที่ประชุม",
      accessor: "meetingDate",
      Cell: ({ row }) => <div className='d-flex justify-content-start'>
        {row.original.meetingDate}
      </div>
    },
    {
      Header: "วันที่อนุมัติ",
      accessor: "approveDate",
      Cell: ({ row }) => <div className='d-flex justify-content-start'>
        {show(pick(row.original, "approveDate", "ApproveDate"))}
      </div>
    },
    {
      Header: "วันที่ทำสัญญา",
      accessor: "contactDate",
      Cell: ({ row }) => <div className='d-flex justify-content-start'>
        {show(pick(row.original, "contactDate", "ContactDate"))}
      </div>
    },
    {
      Header: "วันที่ปิดบัญชี",
      accessor: "closeDate",
      Cell: ({ row }) => <div className='d-flex justify-content-start'>
        {show(pick(row.original, "closeDate", "CloseDate"))}
      </div>
    },
    {
      Header: "สถานะ",
      accessor: "debtStatusName",
      Cell: ({ row }) => <div className='d-flex justify-content-start'>
        {show(pick(row.original, "debtStatusName", "DebtStatusName"))}
      </div>
    },
    {
      Header: "รายละเอียด",
      accessor: "actions",
      Cell: ({ row }) => (
        <div className="d-flex justify-content-center align-items-center gap-1">
          <Button
            size="sm"
            color="primary"
            outline
            className="d-inline-flex align-items-center gap-1"
            onClick={() => openDetail(row.original)}
            title="ดูรายละเอียด"
          >
            <FiSearch />
          </Button>
          {user.roldId == "4" ? <Button
            size="sm"
            color="secondary"
            outline
            className="d-inline-flex align-items-center gap-1"
            onClick={() => openLog(row.original)}
            title="ดูประวัติการเปลี่ยนสถานะ"
          >
            <FiClock />
          </Button> : null}
          {user.roldId == "3" ? <Button
            size="sm"
            color="warning"
            outline
            className="d-inline-flex align-items-center gap-1"
            onClick={() => onClickEdit(row.original)}
            title="แก้ไขสถานะลูกหนี้"
          >
            <FiEdit2 />
          </Button> : null}

        </div>
      ),
    },
  ], []);

  const FormButton = () => null;

  /** Modal รายละเอียด (DetailModal) */
  const DetailModal = () => {
    if (!selected) return null;

    const borrowId = pick(selected, "borrowId", "BorrowId");
    const borrowNumber = pick(selected, "borrowNumber", "BorrowNumber");
    const borrowContact = pick(selected, "borrowContact", "BorrowContact");
    const employee = pick(selected, "employee", "Employee");
    const approveDate = pick(selected, "approveDate", "ApproveDate");
    const contactDate = pick(selected, "contactDate", "ContactDate");
    const startPaymentDate = pick(selected, "startPaymentDate", "StartPaymentDate");
    const lastPaymentDate = pick(selected, "lastPaymentDate", "LastPaymentDate");
    const closeDate = pick(selected, "closeDate", "CloseDate");
    const dataTrain = pick(selected, "dataTrain", "DataTrain") ?? [];

    return (
      <Modal isOpen={detailOpen} toggle={closeDetail} size="lg" className="modal-dialog-scrollable">
        <ModalHeader toggle={closeDetail}>รายละเอียดการกู้ยืม</ModalHeader>
        <ModalBody>
          {/* Top summary card */}
          <div className="card shadow-sm mb-3 border-0">
            <div className="card-body">
              <div className="d-flex flex-wrap gap-3 align-items-center justify-content-between">
                <div>
                  <div className="fw-semibold">เลขที่อ้างอิง: <span className="text-primary">{show(borrowId)}</span></div>
                  <div className="text-muted small">เลขที่คำขอ: {show(borrowNumber)}</div>
                </div>
                <div>
                  <Badge color="info" pill className="me-2">เลขที่สัญญา: {show(borrowContact)}</Badge>
                </div>
              </div>

              <hr className="my-3" />

              <div className="row g-3">
                <div className="col-sm-6">
                  <div className="small text-muted">ผู้ขอกู้</div>
                  <div className="fw-semibold">{show(employee)}</div>
                </div>
                <div className="col-sm-6">
                  <div className="small text-muted">วันที่อนุมัติ</div>
                  <div className="fw-semibold">{show(approveDate)}</div>
                </div>
                <div className="col-sm-6">
                  <div className="small text-muted">วันที่ทำสัญญา</div>
                  <div className="fw-semibold">{show(contactDate)}</div>
                </div>
                <div className="col-sm-6">
                  <div className="small text-muted">วันที่ชำระเงิน (งวดแรก-งวดสุดท้าย)</div>
                  <div className="fw-semibold">
                    {startPaymentDate && startPaymentDate !== "-"
                      ? `${startPaymentDate} - ${show(lastPaymentDate)}`
                      : "-"}
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="small text-muted">วันที่ปิดบัญชี</div>
                  <div className="fw-semibold">{show(closeDate)}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Train list */}
          <h6 className="mb-2">หลักสูตร/การฝึกที่เกี่ยวข้อง</h6>
          {dataTrain.length === 0 && <div className="text-muted">- ไม่พบข้อมูล -</div>}

          <div className="d-flex flex-column gap-3">
            {dataTrain.map((t, idx) => {
              const courseName = pick(t, "courseName", "CourseName");
              const periodTrainCourse = pick(t, "periodTrainCourse", "PeriodTrainCourse");
              const statusApprove = pick(t, "statusApprove", "StatusApprove");
              const inoutTypeName = pick(t, "inoutTypeName", "InoutTypeName");
              const trainingTypeName = pick(t, "trainingTypeName", "TrainingTypeName");
              const trainAmountApprove = pick(t, "trainAmountApprove", "TrainAmountApprove");
              const dataTrainClass = pick(t, "dataTrainClass", "DataTrainClass") ?? [];

              const statusColor = statusApprove === "อนุมัติ" ? "success"
                : statusApprove === "ไม่อนุมัติ" ? "danger"
                  : "secondary";

              return (
                <div key={`course-${idx}`} className="card border-0 shadow-sm">
                  <div className="card-body">
                    <div className="d-flex flex-wrap justify-content-between align-items-start gap-2">
                      <div>
                        <div className="fw-semibold">{show(courseName)}</div>
                        <div className="text-muted small">
                          อบรม: {show(periodTrainCourse)} ชั่วโมง | ประเภทการฝึก: {show(trainingTypeName)} | {show(inoutTypeName)}
                        </div>
                      </div>
                      <div className="d-flex gap-2">
                        <Badge pill color={statusColor}>{show(statusApprove)}</Badge>
                        <Badge pill color="primary">รวมจำนวนเงินที่อนุมัติ: {show(trainAmountApprove)}</Badge>
                      </div>
                    </div>

                    <div className="mt-3">
                      {dataTrainClass.length === 0 ? (
                        <div className="text-muted small">- ไม่พบข้อมูลรุ่นการฝึกอบรม -</div>
                      ) : (
                        <div className="row g-3">
                          {dataTrainClass.map((c, cIdx) => {
                            const className = pick(c, "class", "Class");
                            const payment = pick(c, "payment", "Payment");
                            const employeeAmount = pick(c, "employeeAmount", "EmployeeAmount");
                            const amountApprove = pick(c, "amountApprove", "AmountApprove");
                            const statusApproveC = pick(c, "statusApprove", "StatusApprove");
                            const rejectRemark = pick(c, "rejectRemark", "RejectRemark");
                            const trainDate = pick(c, "trainDate", "TrainDate");
                            const trainSession = pick(c, "trainSession", "TrainSession");

                            const cStatusColor = statusApproveC === "อนุมัติ" ? "success"
                              : statusApproveC === "ไม่อนุมัติ" ? "danger"
                                : "secondary";

                            return (
                              <div className="col-12" key={`class-${idx}-${cIdx}`}>
                                <div className="border rounded-3 p-3">
                                  <div className="d-flex flex-wrap justify-content-between align-items-start gap-2">
                                    <div>
                                      <div className="fw-semibold">รุ่นที่: {show(className)}</div>
                                      <div className="text-muted small">
                                        วงเงินที่ขอ: {show(payment)} | จำนวนผู้เข้าอบรม: {show(employeeAmount)} | วงเงินที่อนุมัติ: {NumberWithCommas(show(amountApprove))}
                                      </div>
                                    </div>
                                    <div className="d-flex gap-2">
                                      <Badge pill color={cStatusColor}>{show(statusApproveC)}</Badge>
                                      {rejectRemark && rejectRemark !== "-" && (
                                        <Badge pill color="warning" title={rejectRemark}>หมายเหตุ</Badge>
                                      )}
                                    </div>
                                  </div>

                                  <div className="mt-2">
                                    {trainDate ? (
                                      <div className="small">
                                        <span className="text-muted">วันที่อบรม: </span>
                                        <span className="fw-semibold">{show(trainDate)}</span>
                                      </div>
                                    ) : (
                                      <div>
                                        <div className="text-muted small mb-1">Sessions</div>
                                        {(trainSession ?? []).length === 0 ? (
                                          <div className="small">- ไม่พบข้อมูล -</div>
                                        ) : (
                                          <ul className="small mb-0">
                                            {trainSession.map((s, sIdx) => {
                                              const sStart = pick(s, "trainSessionStartDate", "TrainSessionStartDate");
                                              const sEnd = pick(s, "trainSessionEndDate", "TrainSessionEndDate");
                                              return (
                                                <li key={`sess-${idx}-${cIdx}-${sIdx}`}>
                                                  {show(sStart)} - {show(sEnd)}
                                                </li>
                                              );
                                            })}
                                          </ul>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={closeDetail}>ปิด</Button>
        </ModalFooter>
      </Modal>
    );
  };


  // --- Log Modal ---
  const LogModal = () => (
    <Modal isOpen={showLogModal} toggle={closeLog} size="xl" className="modal-dialog-scrollable">
      <ModalHeader toggle={closeLog}>
        ประวัติการเปลี่ยนสถานะลูกหนี้
      </ModalHeader>
      <ModalBody>
        {logLoading && (
          <div className="d-flex align-items-center gap-2">
            <Spinner size="sm" /> <span>กำลังโหลดข้อมูล...</span>
          </div>
        )}
        {logError && <Alert color="danger">{logError}</Alert>}
        {!logLoading && !logError && logItems.length === 0 && (
          <div className="text-muted">- ไม่พบประวัติการเปลี่ยนสถานะ -</div>
        )}
        {!logLoading && !logError && logItems.length > 0 && (
          <Table bordered hover responsive className="align-middle">
            <thead className="table-light">
              <tr>
                <th style={{ width: 300 }}>วันที่</th>
                <th>สถานะเดิม → สถานะใหม่</th>
                <th style={{ width: 180 }}>ผู้เปลี่ยน</th>
                <th>หมายเหตุ </th>
                <th style={{ width: 120 }}>ไฟล์แนบ</th> {/* เพิ่มคอลัมน์ */}
              </tr>
            </thead>
            <tbody>
              {logItems.map((it, idx) => {
                const oldName = show(pick(it, "oldDebtName", "OldDebtName"));
                const newName = show(pick(it, "newDebtName", "NewDebtName"));
                const changeBy = show(pick(it, "changeBy", "ChangeBy"));
                const remark = show(pick(it, "remark", "Remark"));
                const dateSt = pick(it, "createDateSt", "CreateDateSt");
                const dateRaw = pick(it, "createDate", "CreateDate");
                const dateShow = dateSt || (dateRaw ? new Date(dateRaw).toLocaleString() : "-");

                const filePath = pick(it, "filePath", "FilePath", "pathFile", "PathFile");
                // const fileUrl = toAbsoluteUrl(filePath);
                return (
                  <tr key={`log-${idx}`}>
                    <td>{dateShow}</td>
                    <td><span className="fw-semibold">{oldName}</span> → <span className="fw-semibold">{newName}</span></td>
                    <td>{changeBy}</td>
                    <td>{remark}</td>
                    <td className="text-center">
                      {filePath ? (
                        <a
                          href={filePath}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1"
                          title="เปิดไฟล์แนบ"
                        >
                          <FiPaperclip /> เปิดไฟล์
                        </a>
                      ) : (
                        <span className="text-muted">-</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={closeLog}>ปิด</Button>
      </ModalFooter>
    </Modal>
  );

  // --- Formik สำหรับ Edit Modal ---
  const initialEditValues = {
    borrowId: pick(dataEdit, "borrowId", "BorrowId") || 0,
    oldDebtId: pick(dataEdit, "debtStatusId", "DebtStatusId") || "",
    oldDebtName: pick(dataEdit, "debtStatusName", "DebtStatusName") || "",
    newDebtId: "",
    newDebtName: "",
    file: null,
    remark: "",
    changeBy: user.fullName
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialEditValues,
    validate: (values) => {
      const errors = {};
      // ต้องเลือกสถานะใหม่
      if (!values.newDebtId && !values.newDebtName) {
        errors.newDebtId = "กรุณาเลือกสถานะใหม่";
      }
      // ถ้าเปลี่ยนสถานะใหม่ไม่เท่าของเดิม → บังคับไฟล์
      const changed =
        (values.newDebtId && String(values.newDebtId) !== String(values.oldDebtId)) ||
        (values.newDebtName && values.newDebtName !== values.oldDebtName);

      if (changed && !values.file) {
        errors.file = "กรุณาแนบไฟล์ประกอบการเปลี่ยนสถานะ";
      }
      return errors;
    },
    onSubmit: async (values) => {
      // console.log("values", values);
      setFormError("");
      setFormSuccess("");
      setSaving(true);
      try {
        const form = new FormData();
        form.append("borrowId", values.borrowId);
        // form.append("oldDebtId", values.oldDebtId ?? "");
        form.append("oldDebtName", values.oldDebtName ?? "");
        // ถ้าเลือกจาก dropdown จะมี newDebtId/newDebtName
        form.append("newDebtId", values.newDebtId ?? "");
        form.append("newDebtName", values.newDebtName ?? "");
        form.append("remark", values.remark ?? "");
        form.append("changeBy", values.changeBy ?? "");

        if (values.file) form.append("file", values.file);

        // NOTE: สมมติ endpoint นี้ (ปรับตาม backend จริง)
        const res = await fetch("/api/Borrow/updateDebtBorrowStatus", {
          method: "POST",
          headers: {
            "token": user?.token || ""
          },
          body: form
        });

        const resJson = await res.json();
        if (!res.ok || resJson?.isSuccess === false) {
          throw new Error(resJson?.message || "ไม่สามารถบันทึกข้อมูลได้");
        }

        setFormSuccess("บันทึกการเปลี่ยนสถานะเรียบร้อย");
        // refresh ตาราง
        await fetchDataBorrow();
        // ปิด modal หลังสักครู่ หรือปิดทันที
        setShowEditForm(false);
        setDataEdit(null);
      } catch (err) {
        setFormError(err?.message || "เกิดข้อผิดพลาด ไม่สามารถบันทึกได้");
      } finally {
        setSaving(false);
      }
    }
  });

  // เมื่อผู้ใช้เลือกสถานะจาก dropdown → set both id & name
  const handleChangeNewDebt = (e) => {
    const val = e.target.value;
    const selectedItem = listDebtStatus.find(x => String(x.debtStatusId) === String(val));
    formik.setFieldValue("newDebtId", val);
    formik.setFieldValue("newDebtName", selectedItem ? selectedItem.debtStatusName : "");
  };

  // console.log("formik values", formik.values);

  return (
    <>
      <CreateTableComponent
        column={COLUMNS}
        dataInput={dataBorrow}
        FormInput={FormButton}
        showEntrie={true}
        showPage={true}
      />
      <DetailModal />
      <LogModal />
      {/* -------- Edit Modal -------- */}
      <Modal
        isOpen={showEditForm}
        toggle={() => { setShowEditForm(false); setDataEdit(null); }}
        size="lg"
        className="modal-dialog-scrollable"
      >
        <ModalHeader toggle={() => { setShowEditForm(false); setDataEdit(null); }}>
          แก้ไขสถานะลูกหนี้
        </ModalHeader>

        <ModalBody>
          {formError && <Alert color="danger" className="mb-3">{formError}</Alert>}
          {formSuccess && <Alert color="success" className="mb-3">{formSuccess}</Alert>}

          <Form onSubmit={formik.handleSubmit}>
            {/* แสดงข้อมูลอ้างอิงเพื่อความชัดเจน */}
            <div className="border rounded-3 p-3 mb-3">
              <div className="row g-3">
                <div className="col-sm-4">
                  <Label className="form-label text-muted small">เลขที่อ้างอิง</Label>
                  <div className="fw-semibold">
                    {show(pick(dataEdit, "borrowId", "BorrowId"))}
                  </div>
                </div>
                <div className="col-sm-4">
                  <Label className="form-label text-muted small">เลขที่คำขอ</Label>
                  <div className="fw-semibold">
                    {show(pick(dataEdit, "borrowNumber", "BorrowNumber"))}
                  </div>
                </div>
                <div className="col-sm-4">
                  <Label className="form-label text-muted small">ผู้ขอกู้</Label>
                  <div className="fw-semibold">
                    {show(pick(dataEdit, "employee", "Employee"))}
                  </div>
                </div>
              </div>
            </div>

            {/* ฟิลด์หลัก */}
            <FormGroup>
              <Label>สถานะเดิม</Label>
              <Input
                type="text"
                value={formik.values.oldDebtName || ""}
                readOnly
                disabled
              />
            </FormGroup>

            <FormGroup>
              <Label>สถานะใหม่ <span className="text-danger">*</span></Label>
              <Input
                type="select"
                name="newDebtId"
                value={formik.values.newDebtId || ""}
                onChange={handleChangeNewDebt}
                onBlur={formik.handleBlur}
              >
                <option value="">-- เลือกสถานะใหม่ --</option>
                {listDebtStatus.map((s) => (
                  <option key={s.debtStatusId} value={s.debtStatusId}>
                    {s.debtStatusName}
                  </option>
                ))}
              </Input>
              {formik.touched.newDebtId && formik.errors.newDebtId && (
                <div className="text-danger small mt-1">{formik.errors.newDebtId}</div>
              )}
            </FormGroup>

            <FormGroup>
              <Label>แนบไฟล์ประกอบการเปลี่ยนสถานะ {/** บังคับเมื่อสถานะเปลี่ยน */}
                {((formik.values.newDebtId && String(formik.values.newDebtId) !== String(formik.values.oldDebtId)) ||
                  (formik.values.newDebtName && formik.values.newDebtName !== formik.values.oldDebtName)) && (
                    <span className="text-danger"> *จำเป็น</span>
                  )}
              </Label>
              <Input
                type="file"
                name="file"
                onChange={(e) => {
                  const file = e.currentTarget.files && e.currentTarget.files[0] ? e.currentTarget.files[0] : null;
                  formik.setFieldValue("file", file);
                }}
                onBlur={formik.handleBlur}
                accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
              />
              {formik.errors.file && (
                <div className="text-danger small mt-1">{formik.errors.file}</div>
              )}
              {formik.values.file && (
                <div className="small text-muted mt-1">ไฟล์ที่เลือก: {formik.values.file.name}</div>
              )}
            </FormGroup>

            <FormGroup>
              <Label>หมายเหตุ</Label>
              <Input
                type="textarea"
                name="remark"
                value={formik.values.remark}
                onChange={formik.handleChange}
                rows={3}
                placeholder="ใส่เหตุผล/รายละเอียดเพิ่มเติม (ถ้ามี)"
              />
            </FormGroup>
          </Form>
        </ModalBody>

        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => { setShowEditForm(false); setDataEdit(null); }}
            disabled={saving}
          >
            ปิด
          </Button>
          <Button
            color="primary"
            onClick={formik.handleSubmit}
            disabled={saving}
            className="d-inline-flex align-items-center gap-2"
          >
            {saving && <Spinner size="sm" />} บันทึกการเปลี่ยนสถานะ
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};
